package com.anjuros.website.templates.template6.modules

import com.anjuros.website.templates.template6.util.ResKey

enum class Template6HeroBadge(
   val  icon: String,
    val text: ResKey

) {
    HeroBadge1(
        icon = "template6_intro1.svg",
        text = ResKey.TEMPLATE6_BADGE1
    ),

    HeroBadge2(
    icon = "template6_intro2.svg",
    text = ResKey.TEMPLATE6_BADGE2
    ),

    HeroBadge3(
    icon = "template6_intro3.svg",
    text = ResKey.TEMPLATE6_BADGE3
    )
}